import Header from './components/Header';
import Hero from './components/Hero';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import Comments from './components/Comments';
import Media from './components/Media';
import Ranking from './components/Ranking';
import Topics from './components/Topics';
import App from './components/App';
import Carousel from './components/Carousel';
import Index from './components/Index';
import Features from './components/Features';
import Cards from './components/Cards';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Updates />
        <FAQ />
        <Comments />
        <Media />
        <Ranking />
        <Topics />
        <App />
        <Carousel />
        <Index />
        <Features />
        <Cards />
        <Contact />
        <About />
      </main>
      <Footer />
    </>
  );
}